/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum FareTypes {
    Published = 'Published',
    Private = 'Private',
    ITX = 'ITX',
    TIM = 'TIM'
}

export function FareTypesFromJSON(json: any): FareTypes {
    return FareTypesFromJSONTyped(json, false);
}

export function FareTypesFromJSONTyped(json: any, ignoreDiscriminator: boolean): FareTypes {
    return json as FareTypes;
}

export function FareTypesToJSON(value?: FareTypes | null): any {
    return value as any;
}

